export default __webpack_public_path__ + "static/media/white-pencil.75857b63.svg";